import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _49481951 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _3b5cbfab = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _69d210c8 = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _124347fa = () => interopDefault(import('../../../pages/comparison/index.vue' /* webpackChunkName: "pages/comparison/index" */))
const _6f07d08e = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _3e1245d9 = () => interopDefault(import('../../../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _22eb505f = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _118f6e0e = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _6d23c108 = () => interopDefault(import('../../../pages/product.vue' /* webpackChunkName: "pages/product" */))
const _19025056 = () => interopDefault(import('../../../pages/roadmap.vue' /* webpackChunkName: "pages/roadmap" */))
const _480be1c2 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _77d7fc6b = () => interopDefault(import('../../../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _fd0711d6 = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _354b0440 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _696b7259 = () => interopDefault(import('../../../pages/use-cases/index.vue' /* webpackChunkName: "pages/use-cases/index" */))
const _69ea5085 = () => interopDefault(import('../../../pages/blog/topics/_slug.vue' /* webpackChunkName: "pages/blog/topics/_slug" */))
const _d45fd654 = () => interopDefault(import('../../../pages/support/topics/_slug.vue' /* webpackChunkName: "pages/support/topics/_slug" */))
const _6d3f5358 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _3c5ba491 = () => interopDefault(import('../../../pages/integrations/_slug.vue' /* webpackChunkName: "pages/integrations/_slug" */))
const _76215b23 = () => interopDefault(import('../../../pages/support/_slug.vue' /* webpackChunkName: "pages/support/_slug" */))
const _67b4d111 = () => interopDefault(import('../../../pages/use-cases/_slug.vue' /* webpackChunkName: "pages/use-cases/_slug" */))
const _15b08a8a = () => interopDefault(import('../../../pages/comparison/_slug.vue' /* webpackChunkName: "pages/comparison/_slug" */))
const _7fc5d5cd = () => interopDefault(import('../../../pages/templates/_slug.vue' /* webpackChunkName: "pages/templates/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _49481951,
    name: "404___en"
  }, {
    path: "/bg",
    component: _3b5cbfab,
    name: "index___bg"
  }, {
    path: "/blog",
    component: _69d210c8,
    name: "blog___en"
  }, {
    path: "/comparison",
    component: _124347fa,
    name: "comparison___en"
  }, {
    path: "/contact",
    component: _6f07d08e,
    name: "contact___en"
  }, {
    path: "/es",
    component: _3b5cbfab,
    name: "index___es"
  }, {
    path: "/integrations",
    component: _3e1245d9,
    name: "integrations___en"
  }, {
    path: "/pricing",
    component: _22eb505f,
    name: "pricing___en"
  }, {
    path: "/privacy-policy",
    component: _118f6e0e,
    name: "privacy-policy___en"
  }, {
    path: "/product",
    component: _6d23c108,
    name: "product___en"
  }, {
    path: "/roadmap",
    component: _19025056,
    name: "roadmap___en"
  }, {
    path: "/search",
    component: _480be1c2,
    name: "search___en"
  }, {
    path: "/support",
    component: _77d7fc6b,
    name: "support___en"
  }, {
    path: "/templates",
    component: _fd0711d6,
    name: "templates___en"
  }, {
    path: "/terms",
    component: _354b0440,
    name: "terms___en"
  }, {
    path: "/use-cases",
    component: _696b7259,
    name: "use-cases___en"
  }, {
    path: "/bg/404",
    component: _49481951,
    name: "404___bg"
  }, {
    path: "/bg/blog",
    component: _69d210c8,
    name: "blog___bg"
  }, {
    path: "/bg/comparison",
    component: _124347fa,
    name: "comparison___bg"
  }, {
    path: "/bg/contact",
    component: _6f07d08e,
    name: "contact___bg"
  }, {
    path: "/bg/integrations",
    component: _3e1245d9,
    name: "integrations___bg"
  }, {
    path: "/bg/pricing",
    component: _22eb505f,
    name: "pricing___bg"
  }, {
    path: "/bg/privacy-policy",
    component: _118f6e0e,
    name: "privacy-policy___bg"
  }, {
    path: "/bg/product",
    component: _6d23c108,
    name: "product___bg"
  }, {
    path: "/bg/roadmap",
    component: _19025056,
    name: "roadmap___bg"
  }, {
    path: "/bg/search",
    component: _480be1c2,
    name: "search___bg"
  }, {
    path: "/bg/support",
    component: _77d7fc6b,
    name: "support___bg"
  }, {
    path: "/bg/templates",
    component: _fd0711d6,
    name: "templates___bg"
  }, {
    path: "/bg/terms",
    component: _354b0440,
    name: "terms___bg"
  }, {
    path: "/bg/use-cases",
    component: _696b7259,
    name: "use-cases___bg"
  }, {
    path: "/es/404",
    component: _49481951,
    name: "404___es"
  }, {
    path: "/es/blog",
    component: _69d210c8,
    name: "blog___es"
  }, {
    path: "/es/comparison",
    component: _124347fa,
    name: "comparison___es"
  }, {
    path: "/es/contact",
    component: _6f07d08e,
    name: "contact___es"
  }, {
    path: "/es/integrations",
    component: _3e1245d9,
    name: "integrations___es"
  }, {
    path: "/es/pricing",
    component: _22eb505f,
    name: "pricing___es"
  }, {
    path: "/es/privacy-policy",
    component: _118f6e0e,
    name: "privacy-policy___es"
  }, {
    path: "/es/product",
    component: _6d23c108,
    name: "product___es"
  }, {
    path: "/es/roadmap",
    component: _19025056,
    name: "roadmap___es"
  }, {
    path: "/es/search",
    component: _480be1c2,
    name: "search___es"
  }, {
    path: "/es/support",
    component: _77d7fc6b,
    name: "support___es"
  }, {
    path: "/es/templates",
    component: _fd0711d6,
    name: "templates___es"
  }, {
    path: "/es/terms",
    component: _354b0440,
    name: "terms___es"
  }, {
    path: "/es/use-cases",
    component: _696b7259,
    name: "use-cases___es"
  }, {
    path: "/",
    component: _3b5cbfab,
    name: "index___en"
  }, {
    path: "/bg/blog/kategorii/:slug",
    component: _69ea5085,
    name: "blog-topics-slug___bg"
  }, {
    path: "/bg/support/kategorii/:slug",
    component: _d45fd654,
    name: "support-topics-slug___bg"
  }, {
    path: "/es/blog/topics/:slug",
    component: _69ea5085,
    name: "blog-topics-slug___es"
  }, {
    path: "/es/support/topics/:slug",
    component: _d45fd654,
    name: "support-topics-slug___es"
  }, {
    path: "/bg/blog/:slug",
    component: _6d3f5358,
    name: "blog-slug___bg"
  }, {
    path: "/bg/integracii/:slug",
    component: _3c5ba491,
    name: "integrations-slug___bg"
  }, {
    path: "/bg/pomoshten-centar/:slug",
    component: _76215b23,
    name: "support-slug___bg"
  }, {
    path: "/bg/primeri-za-polzvane/:slug",
    component: _67b4d111,
    name: "use-cases-slug___bg"
  }, {
    path: "/bg/sravnenie/:slug",
    component: _15b08a8a,
    name: "comparison-slug___bg"
  }, {
    path: "/bg/templeiti/:slug",
    component: _7fc5d5cd,
    name: "templates-slug___bg"
  }, {
    path: "/blog/topics/:slug",
    component: _69ea5085,
    name: "blog-topics-slug___en"
  }, {
    path: "/es/blog/:slug",
    component: _6d3f5358,
    name: "blog-slug___es"
  }, {
    path: "/es/casos-de-uso/:slug",
    component: _67b4d111,
    name: "use-cases-slug___es"
  }, {
    path: "/es/comparar/:slug",
    component: _15b08a8a,
    name: "comparison-slug___es"
  }, {
    path: "/es/integraciones/:slug",
    component: _3c5ba491,
    name: "integrations-slug___es"
  }, {
    path: "/es/plantillas/:slug",
    component: _7fc5d5cd,
    name: "templates-slug___es"
  }, {
    path: "/es/soporte/:slug",
    component: _76215b23,
    name: "support-slug___es"
  }, {
    path: "/support/topics/:slug",
    component: _d45fd654,
    name: "support-topics-slug___en"
  }, {
    path: "/blog/:slug",
    component: _6d3f5358,
    name: "blog-slug___en"
  }, {
    path: "/comparison/:slug",
    component: _15b08a8a,
    name: "comparison-slug___en"
  }, {
    path: "/integrations/:slug",
    component: _3c5ba491,
    name: "integrations-slug___en"
  }, {
    path: "/support/:slug",
    component: _76215b23,
    name: "support-slug___en"
  }, {
    path: "/templates/:slug",
    component: _7fc5d5cd,
    name: "templates-slug___en"
  }, {
    path: "/use-cases/:slug",
    component: _67b4d111,
    name: "use-cases-slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
